// Step 1: Basic tour information - name, status toggle, and concept/published mode
// Toggle triggers validation in TourForm before allowing switch to published
// Updated: Merged Tour Status into Basic Information section

import React from 'react';
import { Tour } from '../../../types/tours';

interface StepBasicsProps {
  formData: Partial<Tour>;
  isConcept: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onConceptToggle: () => void;
}

const StepBasics: React.FC<StepBasicsProps> = ({ formData, isConcept, onChange, onConceptToggle }) => {
  return (
    <div className="space-y-8">
      <div className="bg-[#1F2B1F] rounded-xl p-6 border border-white/10">
        <h3 className="text-lg font-semibold text-white mb-6">Basic Information</h3>

        <div className="space-y-6">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-white/70 mb-2">
              Tour Name <span className="text-red-400">*</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name || ''}
              onChange={onChange}
              placeholder="e.g., Mangrove Night Tour"
              className="w-full px-4 py-3 bg-white/5 border border-white/15 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E85C0D] focus:border-transparent text-white placeholder-white/30 transition-all"
            />
          </div>

          <div className="border-t border-white/10 pt-6">
            <div className="flex items-center justify-between">
              <div>
                <label className="block text-sm font-medium text-white/70 mb-1">Tour Status</label>
                <p className="text-sm text-white/40">
                  {isConcept
                    ? 'Concept -- only the name is required. Fill in other details when ready.'
                    : 'Published -- all required fields must be completed.'}
                </p>
              </div>
              <div className="flex items-center gap-3 shrink-0 ml-4">
                <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium ${
                  isConcept
                    ? 'bg-amber-500/15 text-amber-400 border border-amber-500/30'
                    : 'bg-emerald-500/15 text-emerald-400 border border-emerald-500/30'
                }`}>
                  <span className={`w-2 h-2 rounded-full ${isConcept ? 'bg-amber-400' : 'bg-emerald-400'}`} />
                  {isConcept ? 'Concept' : 'Published'}
                </div>
                <button
                  type="button"
                  onClick={onConceptToggle}
                  className={`relative inline-flex h-7 w-[52px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-[#E85C0D] focus:ring-offset-2 focus:ring-offset-[#1a1a2e] ${
                    isConcept ? 'bg-amber-500' : 'bg-emerald-500'
                  }`}
                >
                  <span
                    className={`pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out ${
                      isConcept ? 'translate-x-0' : 'translate-x-[24px]'
                    }`}
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepBasics;
